import React from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { genres } from '@/data/marketplace';
import { mockSequences } from '@/data/mockSequences';
import { CategoryTile } from '@/components/marketplace/CategoryTile';

const getGenreCount = (genreId: string) => {
  return mockSequences.filter(seq => seq.song?.genre?.toLowerCase() === genreId.toLowerCase()).length;
};

const GenresPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-10 text-center">All Genres</h1>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {genres.map((genre) => (
              <CategoryTile
                key={genre.id}
                title={genre.title}
                icon={genre.icon}
                altText={genre.altText}
                href={`/search?genre=${genre.id}`}
                className="relative"
              >
                {/* Sequence count badge */}
                <span className="absolute top-2 right-2 bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full shadow">
                  {getGenreCount(genre.id)} Sequences
                </span>
              </CategoryTile>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default GenresPage; 